import { useCallback, useEffect, useState } from 'react';

import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import TableBody from '@mui/material/TableBody';
import Typography from '@mui/material/Typography';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

// import { users } from 'src/_mock/user';

// import Scrollbar from 'src/components/scrollbar';

import TableNoData from '../table-no-data';
import UserTableRow from '../user-table-row';
import UserTableHead from '../user-table-head';
import TableEmptyRows from '../table-empty-rows';
import UserTableToolbar from '../user-table-toolbar';
import { emptyRows, applyFilter, getComparator } from '../utils';
import Iconify from '../../../../components/iconify/iconify';
import { useNavigate } from 'react-router-dom';
import { getErrorMessage } from '../../../../utils';
import { toast } from 'react-toastify';
import announcementServices from '../../../../services/announcementServices';
import { TableHeaderStyle } from '../../../../theme/palette';

// ----------------------------------------------------------------------



export default function Announcements() {
  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [data, setData] = useState([])
  const [isArchived, setIsArchived] = useState(false)
  const navigate = useNavigate()

  const handleSort = (event, id) => {
    const isAsc = orderBy === id && order === 'asc';
    if (id !== '') {
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(id);
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data?.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const dataFiltered = applyFilter({
    inputData: data,
    comparator: getComparator(order, orderBy),
    filterName,
  });

  const notFound = !dataFiltered.length && !!filterName;
  const totalFiltered = dataFiltered.length;
  const dataPaginated = dataFiltered.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const getData = useCallback(() => {
    const request = isArchived
      ? announcementServices.getArchived()
      : announcementServices.get();
    request
      .then((res) => {
        setData(res?.data?.data || [])
      })
      .catch((err) => {
        toast.error(getErrorMessage(err))
      });
  }, [isArchived]);

  useEffect(() => {
    getData();
  }, [getData]);


  const handleDeleteRow = (row) => {
    announcementServices.deleteAnnouncement(row._id).then(() => {
      toast.success("Deleted")
      getData();
    }).catch((err) => {
      toast.error(getErrorMessage(err))
    });
  }

  const handleEditRow = (row) => {
    navigate(`EditAnnouncement/${row._id}`)
  }

  const handleArchiveRow = (row) => {
    announcementServices.archiveAnnouncement(row._id).then(() => {
      toast.success("Archived")
      getData();
    }).catch((err) => {
      toast.error(getErrorMessage(err))
    });
  }

  const handleRestoreRow = (row) => {
    announcementServices.restoreAnnouncement(row._id).then(() => {
      toast.success("Restored")
      getData();
    }).catch((err) => {
      toast.error(getErrorMessage(err))
    });
  }

  const handleTabChange = (event, value) => {
    setPage(0);
    setSelected([]);
    setIsArchived(value === 'archived');
  };

  return (
    <div>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Stack>
          <Typography variant="h4">Announcements</Typography>
          <div style={{
            backgroundColor: TableHeaderStyle.border,
            height: "2px"
          }} />
        </Stack>
        <Button onClick={() => navigate("CreateAnnouncement")} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} sx={{ backgroundColor: '#28a745', '&:hover': { backgroundColor: '#218838' }, fontWeight: 'bold' }}>
          New Announcements
        </Button>

      </Stack>

      <Card>
        <Tabs
          value={isArchived ? 'archived' : 'active'}
          onChange={handleTabChange}
          aria-label="Announcement status"
        >
          <Tab value="active" label="Active" />
          <Tab value="archived" label="Archived" />
        </Tabs>

        <UserTableToolbar
          numSelected={selected.length}
          filterName={filterName}
          onFilterName={handleFilterByName}
        />

        <TableContainer sx={{ overflow: 'unset' }}>
          <Table sx={{ minWidth: 800 }}>
            <UserTableHead
              order={order}
              orderBy={orderBy}
              rowCount={dataPaginated?.length || 0}
              numSelected={selected.length}
              onRequestSort={handleSort}
              onSelectAllClick={handleSelectAllClick}
              headLabel={[
                { id: '#', label: '#', width: '5%' },
                { id: 'title', label: 'Title' },
                { id: 'date', label: 'Date' },
                { id: 'time', label: 'Time' },
                { id: 'location', label: 'Location' },

                { id: 'description', label: 'Description' },
                { id: 'file', label: 'File' },

                { id: '' },
              ]}
            />
            <TableBody>
              {dataPaginated.map((row, index) => (
                  <UserTableRow
                  key={row._id || row.id}
                  rowNumber={page * rowsPerPage + index + 1}
                  title={row.title}
                  date={row.date}
                  time={row.time}
                  location={row.location}
                  description={row.description}
                  file={row.url}
                  isArchived={isArchived}
                  onDelete={() => handleDeleteRow(row)}
                  onEdit={() => handleEditRow(row)}
                  onArchive={() => handleArchiveRow(row)}
                  onRestore={() => handleRestoreRow(row)}
                />
              ))}

              <TableEmptyRows
                height={77}
                emptyRows={emptyRows(page, rowsPerPage, totalFiltered)}
              />

              {notFound && <TableNoData query={filterName} />}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          page={page}
          component="div"
          count={totalFiltered}
          rowsPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          rowsPerPageOptions={[5, 10, 25]}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </div>
  );
}
